import Image from "next/image"
import { useSearchBox } from "react-instantsearch"

function CustomSearchBox({ inputRef, classNames, ...props }) {
  const { query, refine } = useSearchBox(props)

  const handleChange = (event) => {
    refine(event.currentTarget.value)
  }

  return (
    <div className="relative w-full">
      <input
        ref={inputRef}
        type="search"
        name="search"
        value={query}
        onChange={handleChange}
        placeholder="Search ripple.com"
        aria-label="Search through ripple.com content"
        className={classNames.input}
      />
      <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <Image
          src="/icons/Search-input.png" // Replace with your search icon path
          alt="Search"
          width={20}
          height={20}
        />
      </div>
    </div>
  )
}

export default CustomSearchBox
